var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UIDatePicker',{attrs:{"error":_vm.errors.startPeriod,"placeholder":_vm.$t('bi.field.placeholder.choose-period'),"disabled-date":_vm.disabledDate,"only-month":""},on:{"change":_vm.handleChange},model:{value:(_vm.formValues.startPeriod),callback:function ($$v) {_vm.$set(_vm.formValues, "startPeriod", $$v)},expression:"formValues.startPeriod"}})
}
var staticRenderFns = []

export { render, staticRenderFns }